export class RankingsResponse {
    
    public rankings : string[] = [];
    
}
